import { render } from "./NavbarButtons.vue?vue&type=template&id=ca4d880a&scoped=true"
import script from "./NavbarButtons.vue?vue&type=script&lang=js"
export * from "./NavbarButtons.vue?vue&type=script&lang=js"

import "./NavbarButtons.vue?vue&type=style&index=0&id=ca4d880a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4d880a"]])

export default __exports__